import React from 'react';
import { Box, Heading, Text } from 'grommet';
import { FieldSocialHandle } from '@helpers/FormFields';

const PlayerSocials = ({ values, updateValues }) => {
  return (
    <Box margin={{ top: 'large' }}>
      <Heading level={5} margin={{ left: 'small' }}>
        Social media
      </Heading>
      <Text>We post great plays on social! To be tagged, enter your info.</Text>
      <FieldSocialHandle
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          updateValues({
            ...values,
            socialTwitterHandle: e.target.value,
          });
        }}
        socialType="twitter"
      />
      <FieldSocialHandle
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          updateValues({
            ...values,
            socialTiktokHandle: e.target.value,
          });
        }}
        socialType="tiktok"
      />
      <FieldSocialHandle
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          updateValues({
            ...values,
            socialInstagramHandle: e.target.value,
          });
        }}
        socialType="instagram"
      />
    </Box>
  );
};

export default PlayerSocials;
